/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { BiEdit } from "react-icons/bi";
import { FaPlus } from "react-icons/fa6";
import { BsThreeDotsVertical } from "react-icons/bs";
import { IoSearch } from "react-icons/io5";
import Loading from "../../Common/Loading";
import Footer from "../../Common/Footer";
import { handleUserRole } from "../../../Redux/UserSlice";
import toast from "react-hot-toast";
import AddEditUserRole from "./AddEditUserRole";

const UserRole = ({
    isVisible,
    setIsVisible,
    setSidebarOpen,
    sidebarOpen,
    isDark,
    setIsDark,
}) => {
    const dispatch = useDispatch();

    const [loadFirst, setloadFirst] = useState(true);
    const [loading, setloading] = useState(false);
    const [UserData, setUsersetData] = useState({
        AllUserRole: [],
        EditUserRole: null
    });
    const [UserModal, setUserModal] = useState(false);
    const [openActionMenuId, setOpenActionMenuId] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        const handleOutsideClick = () => setOpenActionMenuId(null);
        document.addEventListener("click", handleOutsideClick);
        return () => document.removeEventListener("click", handleOutsideClick);
    }, []);

    const fetchUserData = async () => {
        setloading(true)
        const payload = { mode: "SelectList" }
        dispatch(handleUserRole(payload)).then((res) => {
            if (res) {
                toast.remove()
                setUsersetData({ ...UserData, AllUserRole: res?.payload?.data })
                const timer = setTimeout(() => {
                    setloading(false)
                }, 1000);
                return () => clearTimeout(timer);
            }
        })
    }

    useEffect(() => {
        if (loadFirst) {
            fetchUserData()
            setloadFirst(false)
        }
    }, [loadFirst]);

    const toggleModal = () => {
        setUserModal(!UserModal)
        setUsersetData({ ...UserData, EditUserRole: [] })
    }

    const handleEditUser = async (id) => {
        const payload = { mode: "SelectListByID", UsersRoleID: id }
        dispatch(handleUserRole(payload)).then((res) => {
            toast.remove()
            setUsersetData({ ...UserData, EditUserRole: res?.payload?.data })
        })
    }

    const totalRoles = UserData?.AllUserRole?.length || 0;
    const totalAssignedUsers = UserData?.AllUserRole?.reduce((sum, r) => sum + (r?.userCount || 0), 0) || 0;
    const maxUserRoleName = UserData?.AllUserRole?.reduce((max, r) => (r?.userCount > (max?.userCount || 0) ? r : max), null)?.userRole || 'None';

    const filteredRoles = UserData?.AllUserRole?.filter(r => r?.userRole?.toLowerCase().includes(searchTerm.toLowerCase())) || [];

    return (
        <>
            <div className="flex flex-1">
                <div className="page-wrapper relative ml-auto w-[calc(100%-326px)] px-4 pt-[54px] duration-300">

                    {/* Page Header */}
                    <div className="crm-page-header">
                        <div className="flex items-center justify-between">
                            <div>
                                <h1 className="crm-page-title">User Roles</h1>
                                <ol className="crm-breadcrumb">
                                    <li><a href="/Analytics">Disploy</a></li>
                                    <li>/</li>
                                    <li>CRM</li>
                                    <li>/</li>
                                    <li className="active">User Roles</li>
                                </ol>
                            </div>
                            <button className="crm-new-btn" onClick={() => toggleModal()}>
                                <FaPlus size={11} />
                                New User Role
                            </button>
                        </div>
                    </div>

                    <div className="xl:w-full min-h-[calc(100vh-138px)] relative pb-14">

                        {/* Stat Cards */}
                        <div className="crm-stats-row">
                            <div className="crm-stat-card crm-card-indigo">
                                <div className="flex items-start gap-3">
                                    <div className="stat-icon stat-icon-indigo">
                                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                            <rect x="3" y="3" width="18" height="18" rx="2" />
                                            <path d="M21 12H3M12 3v18" />
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="stat-label">Total Roles</p>
                                        <p className="stat-value">{totalRoles}</p>
                                        <p className="stat-trend-up">↑ 1 vs last month</p>
                                    </div>
                                </div>
                            </div>
                            <div className="crm-stat-card crm-card-blue">
                                <div className="flex items-start gap-3">
                                    <div className="stat-icon stat-icon-blue">
                                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                            <circle cx="9" cy="7" r="4" />
                                            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                                            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="stat-label">Assigned Users</p>
                                        <p className="stat-value">{totalAssignedUsers}</p>
                                        <p className="stat-trend-up">↑ 4% vs last month</p>
                                    </div>
                                </div>
                            </div>
                            <div className="crm-stat-card crm-card-orange">
                                <div className="flex items-start gap-3">
                                    <div className="stat-icon stat-icon-orange">
                                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="stat-label">Most Common Role</p>
                                        <p className="stat-value text-base font-semibold truncate max-w-[150px]">{maxUserRoleName}</p>
                                        <p className="stat-trend-up">Highest count</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="crm-panel">
                            <div className="flex items-center justify-end px-4 py-3 border-b border-slate-100 gap-3 flex-wrap">
                                <div className="crm-search-box">
                                    <IoSearch size={14} />
                                    <input
                                        type="text"
                                        placeholder="Search roles..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>
                            </div>

                            {loading && (<div className="h-40 flex items-center justify-center"><Loading /></div>)}
                            {!loading && (
                                <div className="relative scroll-inner">
                                    <table className="crm-table">
                                        <thead>
                                            <tr>
                                                <th scope="col" className="p-4 text-left">
                                                    USER ROLE NAME
                                                </th>
                                                <th scope="col" className="p-4">
                                                    USER COUNT
                                                </th>
                                                <th scope="col" className="p-4 text-center">
                                                    ACTION
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredRoles && filteredRoles.length > 0 ? (
                                                filteredRoles.map((item, index, arr) => {
                                                    const showUpward = index >= arr.length - 2 && arr.length > 1;
                                                    return (
                                                        <tr className="hover:bg-slate-50 transition-colors border-b border-slate-100 text-center" key={index}>
                                                            <td className="p-4 font-semibold text-slate-800 text-left">
                                                                {item?.userRole}
                                                            </td>
                                                            <td className="p-4 text-sm text-slate-600 text-left">
                                                                {item?.userCount}
                                                            </td>
                                                            <td className="p-4 text-center whitespace-nowrap ">
                                                                <div className="relative inline-block text-left">
                                                                    <button
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            setOpenActionMenuId(openActionMenuId === item.usersRoleID ? null : item.usersRoleID);
                                                                        }}
                                                                        className="p-1.5 text-slate-500 hover:text-slate-800 hover:bg-slate-100 rounded-lg transition-colors"
                                                                    >
                                                                        <BsThreeDotsVertical size={16} />
                                                                    </button>
                                                                    {openActionMenuId === item.usersRoleID && (
                                                                        <div className={`absolute right-0 w-36 bg-white border border-slate-100 rounded-lg shadow-lg py-1 z-50 animate-in fade-in duration-100 flex flex-col ${showUpward ? 'bottom-full mb-1 slide-in-from-bottom-1' : 'top-full mt-1 slide-in-from-top-1'}`}>
                                                                            <button
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    setUserModal(true);
                                                                                    handleEditUser(item?.usersRoleID);
                                                                                    setOpenActionMenuId(null);
                                                                                }}
                                                                                className="w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors text-left"
                                                                            >
                                                                                <BiEdit size={14} className="text-indigo-500" />
                                                                                <span>Edit</span>
                                                                            </button>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan="3" className="text-center py-4 text-slate-500">
                                                        Not Found.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {UserModal && <AddEditUserRole setUserModal={setUserModal} fetchUserData={fetchUserData} userRoleData={UserData?.EditUserRole} toggleModal={toggleModal} />}
        </>
    );
};

export default UserRole;


